import useField from 'components/form/useField'
import styled, { css } from 'styled-components/macro'
import { body1, caption } from 'styles/mixins/textstyles'

const triangle = (color) => css`
  height: 0;
  width: 0;
  border-left: 0.6rem solid transparent;
  border-right: 0.6rem solid transparent;
  border-top: 0.8rem solid ${color};
  position: absolute;
  top: ${(props) => (props.tight ? '2.7rem' : '3.5rem')};
  right: 0;
  content: ' ';
  pointer-events: none;
`

const SelectWrapper = styled.div`
  position: relative;

  select {
    ${(props) => body1(props.hasValue ? props.theme.colors.black : props.theme.colors.greyBase)}
    width: 100%;
    border: 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};
    border-radius: 0;
    padding-left: 0;
    outline: none !important;
    background: none;
    appearance: none;
    border-radius: 0;
    line-height: 2.2rem;
    padding-bottom: 0.2rem;
    padding-right: 2rem;

    @supports (-webkit-overflow-scrolling: touch) {
      height: 3.3rem;
    }

    &[disabled] {
      color: ${(props) => props.theme.colors.greyLight};
    }

    :focus {
      border-bottom: 1px solid ${(props) => props.theme.colors.primaryBase};
    }
  }

  ${(props) =>
    props.noLabel &&
    css`
      label {
        display: none;
      }
    `}

  select::-ms-expand {
    display: none;
  }

  &:after {
    ${(props) => triangle(props.disabled ? props.theme.colors.greyLight : props.theme.colors.primaryBase)}
    position: absolute;

    ${(props) =>
      props.noLabel &&
      css`
        top: 0.75rem;
      `}
  }
`

const LabelText = styled.label`
  ${(props) => caption(props.theme.colors.black, 'medium')}
  display: block;
  text-align: left;
  color: ${(props) => props.theme.colors.greyBase};
  font-size: 1.3rem;
  padding-top: ${(props) => (props.tight ? '.2rem' : '1rem')};
  padding-bottom: 0.1rem;

  ${(props) =>
    props.focused &&
    css`
      color: ${(props) => props.theme.colors.primaryBase};
    `}

  ${(props) =>
    props.error &&
    css`
      color: ${(props) => props.theme.colors.errorBase};
    `}
`

const Label = (props) => {
  const { label, error, value, focused, tight, id } = props
  const text = error || (value && label) || '\u00A0'
  return (
    <LabelText focused={focused} error={error} tight={tight} id={id}>
      {text}
    </LabelText>
  )
}

const Select = (props) => {
  const { name, validate, defaultValue, activeLabel, label, cancelable, className, ...rest } = props
  const { value, setValue, error, id } = useField({ name, validate, defaultValue })
  const floatingLabel = !!value && (activeLabel || label)

  const handleChange = (event) => {
    setValue(event.target.value)
    if (rest.onChange) {
      event.persist()
      rest.onChange(event)
    }
  }

  return (
    <SelectWrapper
      className={className}
      noLabel={!label}
      tight={rest.tight}
      hasValue={!!value}
      disabled={rest.disabled}
    >
      <Label id={`${id}-label`} focused={false} label={floatingLabel} value={value} error={error} tight={props.tight} />
      <select id={id} name={name} {...rest} onChange={handleChange} value={value}>
        {label && (
          <option disabled={!!value && !cancelable} value="">
            {label}
          </option>
        )}
        {props.children}
      </select>
    </SelectWrapper>
  )
}

export default Select
